var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('the-header',{staticClass:"main-layout__header"}),_c('main',{staticClass:"main-layout__main"},[_c('router-view')],1),_c('the-footer',{staticClass:"main-layout__footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }